import "./rsa.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import choose from "../images/rsa-choose.png";
import rsaBanner from "../images/rsa-banner.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Rsa = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");


                   useEffect( () => {
                         AOS.init({
                              offset: 0,
                              duration: 1000,
                              once: true
                                });
                               }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages(first: 100) {
              edges {
                node {
                  rsa {
                    productText
                    productTextContd
                    sections {
                      buttonLink
                      buttonName
                      heading
                      caption
                      image {
                        mediaItemUrl
                      }
                    }
                    productInfo {
                      heading
                      explanation
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    hero {
                      buttonLink
                      buttonName
                      fieldGroupName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.edges[19].node.rsa.hero);
        setHeroMobile(result.data.pages.edges[19].node.rsa.heromobile);
        setBusinessSections(result.data.pages.edges[19].node.rsa.sections);
        setProductInfo(result.data.pages.edges[19].node.rsa.productInfo);
        setProductText(result.data.pages.edges[19].node.rsa.productText);
        setProductTextContd(
          result.data.pages.edges[19].node.rsa.productTextContd,
        );
      });
  }, []);

  let businessSectionsDisplay;
  let productInfoDisplay;
  let heroBannerDisplay;
  let heroMobileDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="rsa-cover">
        <img className="rsa-bg" src={banner.image.mediaItemUrl} />
        <div className="rsa-content">
          <div className="rsa-txt">
            <h1 className="rsa-h1" data-aos="fade-up" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p"  data-aos="fade-up" data-aos-delay="200"> {banner.caption} </p>
            <a href={banner.buttonLink} className="btn-trns"  data-aos="fade-up" data-aos-delay="200" >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileDisplay = heroMobile.map((banner, i) => (
      <div className="rsa-cover">
        <img className="rsa-bg" src={banner.image.mediaItemUrl} />
        <div className="rsa-content">
          <div className="rsa-txt">
            <h1 className="rsa-h1" data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200" >{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200" >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) => (
      <div className="card rsa-crd text-start">
        <figure className="compact-settings-rsa-works">
          <p className="rsa-works-numeral" data-aos="fade-up" data-aos-delay="200">{i + 1}</p>
          <figcaption>
            <h5 className="card-subtitle pb-2 statement-hdr" data-aos="fade-up" data-aos-delay="200">{info.heading}</h5>
            <p className="card-text grey-p-rsa" style={{ fontSize: "16px" }} data-aos="fade-up" data-aos-delay="200">
              {info.explanation}
            </p>
          </figcaption>
        </figure>
      </div>
    ));
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="values-rsa compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <Link class="open-acc-btn grey-p mt-3" to={section.buttonLink} data-aos="fade-up" data-aos-delay="200">
              {section.buttonName}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </Link>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className="rsa-div d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="d-flex justify-content-end">
            <img className="rsa-img" src={section.image.mediaItemUrl} />
          </div>

          <div className="values-rsa">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <Link class="open-acc-btn grey-p mt-3" to={section.buttonLink} data-aos="fade-up" data-aos-delay="200">
              {section.buttonName}{" "}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </Link>
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="rsa-container d-none d-sm-block">{heroBannerDisplay}</div>

      <div className="rsa-container d-block d-sm-none">{heroMobileDisplay}</div>

      <div className="containeer">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 padding-section-standard-bottom"
        >
          <div className=" width-fifty">
            <h2 className="rsa-h2 pb-4">What is RSA? </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p grey-color">{productText} </p>

            <p className="grey-p grey-color mt-3">{productTextContd} </p>
          </div>
        </div>
      </div>

      <div className="black-cont-rsa">
        <div
          id="mobile-view"
          className="containeer row d-flex justify-content-between text-center "
        >
          <div className="text-center pb-4">
            <p className="orange-p-rsa pb-2">RSA PROCESS</p>
            <h2 className="rsa-h2" style={{ color: "#FFFFFF" }}>
              How does RSA work?
            </h2>
          </div>
          <div id="mobile-view" className="d-flex justify-content-between">
            {productInfoDisplay}
          </div>
        </div>
      </div>

      <div className="containeer d-none d-sm-block">
        {businessSectionsDisplay}
      </div>

      <div className="containeer d-block d-sm-none"></div>
          <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Rsa;
